import { useAppSelector } from "../redux/store";
import {
  selectAudienceCount,
  selectCountdown,
  selectRoomCode,
  selectPlayerDetails,
} from "../redux/selectors";

export const useGameFormData = () => {
  const playerState = useAppSelector(selectPlayerDetails);
  const metaState = useAppSelector((state) => state.meta);
  const roomCode = useAppSelector(selectRoomCode);
  const numAudience = useAppSelector(selectAudienceCount);
  const countdown = useAppSelector(selectCountdown);

  function getExtraLabel() {
    return numAudience > 0 ? numAudience.toString() : undefined;
  }

  return {
    playerState,
    roomCode,
    countdown,
    extraTopLabel: getExtraLabel(),
    error: metaState.error,
    loading: metaState.loading,
  };
};
